import {
  useEffect,
  useState
} from "react";

import {
  useParams,
  useNavigate
} from "react-router-dom";

import axios from "axios";

function RecuPage() {

  const { id } =
    useParams();

  const navigate =
    useNavigate();

  const [data, setData] =
    useState(null);

  // =====================
  // FETCH
  // =====================

  useEffect(() => {

    axios
      .get(
        `/api/recus/${id}`
      )
      .then((res) =>
        setData(res.data)
      )
      .catch((err) => {

        console.error(err);

        setData(null);

      });

  }, [id]);

  // =====================
  // LOADING
  // =====================

  if (!data) {

    return (
      <p className="p-4 md:p-6 text-center">
        Chargement...
      </p>
    );

  }

  const dateValue =
    data.date_recu ||
    data.date_paiement;

  // =====================
  // RENDER
  // =====================

  return (
    <div className="p-3 md:p-6 flex flex-col items-center min-h-[100dvh] bg-gray-100">

      {/* RECEIPT */}
      <div className="bg-white shadow-2xl rounded-2xl p-5 md:p-6 w-full max-w-sm border">

        {/* HEADER */}
        <div className="text-center mb-4">

          <h3 className="font-bold text-xl text-gray-800">
            ALTA IMMEUBLE
          </h3>

          <p className="text-xs text-gray-500 mt-1">
            Gestion immobilière premium
          </p>

        </div>

        <hr className="my-3" />

        <p className="text-center font-bold text-lg">
          REÇU DE PAIEMENT
        </p>

        <hr className="my-3" />

        {/* INFOS */}
        <div className="space-y-3 text-sm md:text-base">

          <div>

            <span className="font-semibold">
              Date :
            </span>{" "}

            {dateValue
              ? new Date(
                  dateValue
                ).toLocaleString()
              : "-"}

          </div>

          <div className="break-words">

            <span className="font-semibold">
              Client :
            </span>{" "}

            {data.nom}{" "}
            {data.prenom}

          </div>

          <div>

            <span className="font-semibold">
              Appartement :
            </span>{" "}

            {
              data.appartement
            }

          </div>

        </div>

        {/* MONTANT */}
        <div className="text-center text-3xl font-bold mt-6 text-green-600">

          {data.montant} $

        </div>

      </div>

      {/* ACTIONS */}
      <div className="mt-5 w-full max-w-sm flex flex-col md:flex-row gap-3">

        <button
          onClick={() =>
            window.open(
              `/api/recus/pdf/${id}`
            )
          }
          className="flex-1 px-4 py-3 bg-green-600 text-white rounded-xl hover:bg-green-700 transition"
        >
          📄 PDF
        </button>

        <button
          onClick={() =>
            window.print()
          }
          className="flex-1 px-4 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition"
        >
          🖨️ Imprimer
        </button>

        <button
          onClick={() =>
            navigate(-1)
          }
          className="flex-1 px-4 py-3 bg-gray-600 text-white rounded-xl hover:bg-gray-700 transition"
        >
          Retour
        </button>

      </div>

    </div>
  );
}

export default RecuPage;